import React, { useEffect, useRef, useState } from "react"

import PropTypes from "prop-types"

import "./sample-letter-field.scss"

export const SampleLetterField = ({
  id,
  label,
  hint,
  isTextarea,
  invalidMessage,
  isRequired,
  isInline,
  align,
  autoComplete,
  className,
}) => {
  const [value, setValue] = useState("")
  const [width, setWidth] = useState(0)

  const hiddenPlaceholder = useRef(null)

  const tooltip = useRef(null)

  useEffect(() => {
    setWidth(hiddenPlaceholder.current.getBoundingClientRect().width)
  }, [value])

  const toggleTooltip = () => {
    const isHidden = tooltip.current.style.display !== "block"
    tooltip.current.style.display = isHidden ? "block" : "none"
  }

  const handleOnChange = e => {
    if (isTextarea) {
      setTextareaHeight(e)
    }
    setValue(e.target.value)
  }

  const setTextareaHeight = e => {
    const textarea = e.target
    textarea.style.height = "80px"
    textarea.style.height = textarea.scrollHeight + "px"
  }

  const placeholder = `[${label.toLowerCase()}]${isRequired ? "*" : ""}`

  return (
    <div
      className={`sample-letter-field ${
        isInline ? "is-inline" : ""
      } ${className}`}
      style={{
        maxWidth: isTextarea
          ? "100%"
          : !isInline || width === 0
          ? "initial"
          : width,
        width: isTextarea
          ? "100%"
          : !isInline || width === 0
          ? "initial"
          : width + 16,
      }}
    >
      <label htmlFor={id} className="sr-only">
        {label} {isRequired ? "(required)" : ""}
      </label>

      <div>
        <div
          ref={hiddenPlaceholder}
          aria-hidden="true"
          className={`
            sample-letter-field-hidden-placeholder 
            text-${align}
          `}
        >
          {value || placeholder}
        </div>

        {React.createElement(isTextarea ? "textarea" : "input", {
          id,
          name: id,
          onFocus: toggleTooltip,
          onBlur: toggleTooltip,
          value,
          onChange: handleOnChange,
          placeholder: placeholder,
          required: isRequired,
          autoComplete,
          className: `
            form-control 
            sample-letter-field-control 
            hide-placeholder-print
            text-${align}
            ${isInline ? "is-inline" : ""}
            ${isTextarea ? "textarea" : ""}
          `,
        })}
      </div>

      {invalidMessage && (
        <div className={`invalid-feedback text-${align}`}>{invalidMessage}</div>
      )}

      <span ref={tooltip} className="valid-tooltip sample-letter-field-tooltip">
        <strong>{label}</strong>
        {hint && <span className="sample-letter-field-hint">{hint}</span>}
      </span>
    </div>
  )
}

SampleLetterField.propTypes = {
  label: PropTypes.string,
  hint: PropTypes.string,
  invalidMessage: PropTypes.string,
  isRequired: PropTypes.bool,
  isInline: PropTypes.bool,
  autoComplete: PropTypes.string,
  align: PropTypes.oneOf(["left", "center", "right"]),
}

SampleLetterField.defaultProps = {
  align: "left",
}
